import {useCallback, useMemo, useReducer as ReactReducer, useRef} from "react";
import {Payload, State} from "./SuggestionsPopup.interfaces";

const reduce = (state: State, payloads: Array<Payload>) => {
    payloads.forEach(payload => {
        const payloadType = payload.type;
        switch (payloadType) {
            case "clearSuggestions":
                state.suggestions = undefined;
                break;
            case "setSuggestions":
                state.suggestions = payload.value;
                break;
            case "setPrevMessage":
                state.prevMessage = payload.value;
                break;
            case "toggleCreativeCommonOnly":
                state.creativeCommonOnly = !state.creativeCommonOnly;
                break;
            case "setKeywords":
                state.keywords = payload.value;
                break;
            case "setKeywordsTimeout":
                state.keywordsTimeout = payload.value;
                break;
            case "setCancelToken":
                state.cancelToken = payload.value;
                break;
            default:
                throw new Error("Payload type " + payloadType + " not implemented");
        }
    });
}

const getInitialState = (): State => {
    return {
        suggestions: [],
        prevMessage: "",
        creativeCommonOnly: true,
        keywords: "",
        keywordsTimeout: undefined,
        cancelToken: undefined,
    }
}

export const useReducer = () => {
    const initialState = useMemo(() => getInitialState(), []);
    const stateRef = useRef<Readonly<State>>(initialState);
    const [, render] = ReactReducer(() => [], []);

    const dispatch = useCallback((payload: Payload | Array<Payload>, reRender?: boolean) => {
        reduce(stateRef.current, Array.isArray(payload) ? payload : [payload]);
        if (reRender === undefined || reRender) render();
    }, []);

    return {state: stateRef.current, dispatch};
}